import React, { useState, useImperativeHandle, forwardRef, useRef } from 'react'
import ReactDOM from 'react-dom'
import Api from '../../../../../_helpers/Api'
import { trans } from '../../../../../_providers/Translation'

import loader from '../../../../../assets/img/loader.svg'

function AddComment(props, ref) {
    const [state, setState] = useState({
        overlay: false,
        modal: false,
        loading: false,
        reservationId: null,
    })

    const textareaRef = useRef(null)

    useImperativeHandle(ref, () => ({
        open: (reservationId) => {
            setState(prev => ({ ...prev, overlay: true, reservationId }))
            setTimeout(() => setState(prev => ({ ...prev, modal: true })), 50)
        },
        close: () => handleCancel(),
    }))

    const handleCancel = e => {
        if (e) e.preventDefault()
        setState(prev => ({ ...prev, modal: false }))
        setTimeout(() => setState(prev => ({ ...prev, overlay: false, reservationId: null })), 50)
    }

    const handleSend = e => {
        e.preventDefault()

        const comment = textareaRef.current.value.trim()
        if (!comment) return

        setState(prev => ({ ...prev, loading: true }))

        Api.post('reservations/comments/add', { id: state.reservationId, comment })
            .then(res => {
                if (props.callback) props.callback(res.data)
                textareaRef.current.value = ''
                handleCancel()
            })
            .finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    return ReactDOM.createPortal(
        <form className={`${state.overlay ? 'visible' : ''} overlay`} onSubmit={handleSend}>
            <div className={`${state.modal ? 'show' : ''} popup-primary large`}>
                <div className="head-new">
                    <div className="texts">
                        <h2>{trans('headings.addComment')}</h2>
                        <p>{trans('subheadings.addComment')}</p>
                    </div>
                    <span className="close" onClick={handleCancel} />
                </div>
                <div className="popup-container-read-only">
                    <div className="col">
                        <label>{trans('labels.comments')}</label>
                        <textarea
                            ref={textareaRef}
                            name="comment"
                            autoFocus
                        />
                    </div>
                </div>
                <div className="footer align-right">
                    {state.loading
                        ? <img src={loader} alt="loading" />
                        : <>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                            <button type="button" onClick={handleCancel}>
                                {trans('buttons.cancel')}
                            </button>
                        </>
                    }
                </div>
            </div>
        </form>,
        document.body
    )
}

export default forwardRef(AddComment)
